import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import AddWordTemplate from "./AddWordTemplate";
import { useDispatch, useSelector } from "react-redux";
import { SetWordTemplateLocked, getSearchDocuments, getWordTempLockedStatus, 
    getWordTemplates, loadDocumentSearch, loadWordTemplates, getWordLoading } from "../../store/wordProccessing";
import Moment from "react-moment";
import { getAlert } from "../../../services/appAlerts";
import WordVersionHistory from "./WordVersionHistory";
import NotesPopover from "../../../comman/NotesPopover";

const isHtml = (str) => {
    if (!str) return false;
    return str.trim().startsWith("<") || /<[a-z][\s\S]*>/i.test(str);
};

const WordEditor = (props) => {
    const { workflowTask ,handleUpdateComponent} = props;
    const [wordTemplates, setWordTemplates] = useState([]);
    const [selectedKey, setSelectedKey] = useState("home");
    const [selectedTempId, setSelectedTempId] = useState(0);
    const [verSelectedTempId, setVerSelectedTempId] = useState(0);
    const [verSelectedTemp, setVerSelectedTemp] = useState(null);
    const [selectedTemp, setSelectedTemp] = useState(null);
    const [searchParam,setSearchParam]=useState("");
    const [updateCompStatus, setUpdateCompStatus] = useState(false);
    const [viewTemp, setViewTemp] = useState(null);

    const wordTemplatesSelector = useSelector(getWordTemplates);
    const wordTempLockedStatusSelector = useSelector(getWordTempLockedStatus);
    const searchDocumentsSelector = useSelector(getSearchDocuments);
    const isLoading = useSelector(getWordLoading);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (workflowTask?.ciid > 0){
            dispatch(loadWordTemplates(workflowTask.ciid));
            setUpdateCompStatus(true);
        }
    }, [dispatch, workflowTask?.ciid]);

    const getLatestVersions = (templates) => {
        const latestMap = new Map();
        templates.forEach((item) => {
            const masterId = item.templateId > 0 ? item.templateId : item.id;
            const existing = latestMap.get(masterId);
            if (!existing || item.version > existing.version) {
                latestMap.set(masterId, item);
            }
        });
        return Array.from(latestMap.values());
    };

    useEffect(() => {
        if (wordTemplatesSelector.length > 0) {
            const latest = getLatestVersions(wordTemplatesSelector);
            setWordTemplates(latest);
            let wordItems = "";
            wordTemplatesSelector.map((x, key) => {
                if (key > 0) wordItems += ",";
                wordItems += x.id;
            });
            if (updateCompStatus) {
                handleUpdateComponent(wordItems);
                setUpdateCompStatus(false);
            }
        } else {
            setWordTemplates([]);
        }
    }, [wordTemplatesSelector]);

    const handleSubmit = async () => {
        setSelectedKey("home");
        setSelectedTemp(null);
        setSelectedTempId(0);

        if (workflowTask?.ciid > 0){
            dispatch(loadWordTemplates(workflowTask.ciid))
            setUpdateCompStatus(true);
        }
    };

    const handleEditTemp = (item) => {
        //dispatch(updateAppSchedule(item));
    };

    const handleSelectTab = (tab) => {
        setSelectedKey(tab);
    }

    const handleResetSelection = () => {
        setSelectedTempId(0);
        setSelectedTemp(null);
    }

    const handleSelectTemplate = (item) => {
        if (selectedTempId === item.id) {
            handleResetSelection();
        } else {
            setSelectedTemp(item);
            setSelectedTempId(item.id);
        }
    }

    const handleWordTemplateLock = (item) => {
        dispatch(SetWordTemplateLocked(item.id));
    }

    useEffect(() => {
        if (wordTempLockedStatusSelector) {
            getAlert("", "Locked Successfully", "success");
            if (workflowTask?.ciid > 0)
                dispatch(loadWordTemplates(workflowTask.ciid));
            
            if (selectedTemp && selectedTemp.id === selectedTempId) {
                setSelectedTemp({ ...selectedTemp, isEdit: false });
            }
        }
    }, [wordTempLockedStatusSelector]);

    const handleVersionViewTemp=(item)=>{
        if(item){
            setVerSelectedTempId(item.id);
            setVerSelectedTemp(item);
        }
        else{
            setVerSelectedTemp(null);
            setVerSelectedTempId(0)
        }
    }

    const handleClickSearch = () => {
        dispatch(loadDocumentSearch({
            "query": searchParam
        }))
    }

    useEffect(()=>{
        if(searchDocumentsSelector.length > 0){
            const docList=[];
            searchDocumentsSelector.map((d,key)=>{
                const dObj={
                    id:key+1,
                    templateName:d.document.title,
                    notes:d.document.description,
                    templateType:d.document.author,
                    createdDateTime:d.document.createdDate,
                    version:1,
                    isEdit:true,
                    templateData:d.document.tags.join(", ")
                }
                docList.push(dObj);
            })

            setWordTemplates(docList);
        }
    },[searchDocumentsSelector]);

    const handleResetSearch=()=>{
        setSearchParam("");
        setWordTemplates([]);

        if (workflowTask?.ciid > 0)
            dispatch(loadWordTemplates(workflowTask.ciid));
    }

    const getPopover = (notes, placement = "top") => {
        return <NotesPopover notes={notes} placement={placement} />;
    };

    const renderSelectedReportCard = () => {
        if (selectedTempId === 0 || !selectedTemp) return null;

        return (
            <div className="rt-msg-selected-card">
                <div className="rt-msg-selected-info">
                    <div className="rt-msg-selected-avatar">
                        <i className="fa fa-file-word-o" aria-hidden="true" style={{ fontSize: "20px" }} />
                    </div>
                    <div className="rt-msg-selected-meta">
                        <strong>{selectedTemp.templateName}</strong>
                        <span>
                            <i className="fa fa-info-circle" aria-hidden="true" />
                            Report ID #{selectedTempId}
                            <span>&bull;</span>
                            <span className={`rt-form-status-tag ${selectedTemp.isEdit ? "is-pending" : "is-updated"}`}>
                                {selectedTemp.isEdit ? "Unlocked" : "Locked"}
                            </span>
                        </span>
                    </div>
                </div>
                <div className="rt-msg-selected-actions">
                    <button
                        className="rt-form-action-btn is-view"
                        onClick={() => handleSelectTab("add")}
                        type="button"
                    >
                        <i className="fa fa-pencil" aria-hidden="true" /> Edit Report
                    </button>
                    <button
                        className="rt-form-action-btn is-history-btn"
                        onClick={() => handleSelectTab("history")}
                        type="button"
                        title="View Version History"
                    >
                        <i className="fa fa-history" aria-hidden="true" /> History
                    </button>
                    {selectedTemp.isEdit ? (
                        <button
                            className="rt-form-action-btn is-delete"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleWordTemplateLock(selectedTemp);
                            }}
                            type="button"
                            title="Lock Report"
                        >
                            <i className="fa fa-lock" aria-hidden="true" /> Lock
                        </button>
                    ) : (
                        <span className="rt-action-label-badge is-sent">
                            <i className="fa fa-lock" aria-hidden="true" /> Locked
                        </span>
                    )}
                    <button
                        className="rt-form-action-btn is-clear"
                        onClick={handleResetSelection}
                        type="button"
                        title="Clear selection"
                    >
                        <i className="fa fa-times" aria-hidden="true" />
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="rt-editor-tabs rt-form-workbench">
            <style>{`
              :root {
                --primary-color: #2563eb;
                --primary-hover: #1d4ed8;
                --primary-soft: #eff6ff;
                --secondary-color: #64748b;
                --secondary-hover: #475569;
                --border-color: #e2e8f0;
                --bg-light: #f8fafc;
                --text-main: #1e293b;
                --text-muted: #64748b;
              }

              .rt-form-workbench {
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                background: transparent !important;
                color: #1e293b !important;
                --task-accent: #2563eb !important;
                --task-soft: #eff6ff !important;
                position: relative;
              }

              @keyframes loadingBar {
                0%   { width: 0%; opacity: 1; }
                70%  { width: 85%; opacity: 1; }
                100% { width: 100%; opacity: 0; }
              }

              .wf-loading-bar {
                position: absolute !important;
                top: 0 !important;
                left: 0 !important;
                right: 0 !important;
                height: 3px !important;
                background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb) !important;
                background-size: 200% 100% !important;
                animation: loadingBar 1.6s ease-in-out infinite !important;
                z-index: 10 !important;
              }

              @keyframes shimmer {
                0%   { background-position: -600px 0; }
                100% { background-position: 600px 0; }
              }

              .skeleton-cell {
                display: block;
                height: 13px;
                border-radius: 6px;
                background: linear-gradient(
                  90deg,
                  #f1f5f9 25%,
                  #e2e8f0 50%,
                  #f1f5f9 75%
                );
                background-size: 600px 100%;
                animation: shimmer 1.4s ease-in-out infinite;
              }

              .skeleton-cell.sk-short  { width: 40%; }
              .skeleton-cell.sk-medium { width: 65%; }
              .skeleton-cell.sk-long   { width: 85%; }
              .skeleton-cell.sk-full   { width: 92%; }

              .skeleton-row td {
                padding: 14px 16px !important;
              }

              .rt-msg-tab-bar {
                display: flex;
                align-items: stretch;
                gap: 4px;
                border-bottom: 2px solid #f1f5f9;
                margin-bottom: 12px !important;
                padding: 8px 4px 0;
                position: relative;
              }

              .rt-msg-tab-btn {
                position: relative;
                display: inline-flex;
                align-items: center;
                gap: 7px;
                border: none;
                background: transparent;
                padding: 9px 16px 11px;
                font-size: 14px;
                font-weight: 500;
                color: #64748b;
                cursor: pointer;
                border-radius: 8px 8px 0 0;
                transition: color 0.2s ease, background 0.2s ease;
                outline: none;
                white-space: nowrap;
              }
              .rt-msg-tab-btn i {
                font-size: 13px;
                transition: color 0.2s ease;
              }
              .rt-msg-tab-btn:hover {
                color: #1e293b;
                background: rgba(37,99,235,0.04);
              }
              .rt-msg-tab-btn:focus,
              .rt-msg-tab-btn:focus-visible,
              .rt-msg-tab-btn:active {
                outline: none !important;
                box-shadow: none !important;
                border-color: transparent !important;
              }
              .rt-msg-tab-btn.active {
                color: var(--task-accent, #2563eb);
                font-weight: 500;
              }
              .rt-msg-tab-btn.active i {
                color: var(--task-accent, #2563eb);
              }
              .rt-msg-tab-btn::after {
                content: "";
                position: absolute;
                bottom: -2px;
                left: 0;
                right: 0;
                height: 2px;
                background: var(--task-accent, #2563eb);
                border-radius: 2px 2px 0 0;
                transform: scaleX(0);
                transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
              }
              .rt-msg-tab-btn.active::after {
                transform: scaleX(1);
              }
              .rt-msg-tab-badge {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                min-width: 20px;
                height: 20px;
                padding: 0 6px;
                border-radius: 999px;
                font-size: 12px;
                font-weight: 600;
                background: #f1f5f9;
                color: #64748b;
                border: 1px solid #e2e8f0;
                line-height: 1;
                transition: all 0.2s ease;
              }
              .rt-msg-tab-btn.active .rt-msg-tab-badge {
                background: var(--task-soft, rgba(37,99,235,0.1));
                color: var(--task-accent, #1d4ed8);
                border-color: var(--task-accent, rgba(37,99,235,0.2));
              }

              .rt-msg-panel {
                animation: rtMsgTabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
                flex: 1 1 auto !important;
                min-height: auto !important;
                overflow-y: visible !important;
                overflow-x: hidden !important;
                padding-top: 4px !important;
                padding-right: 4px !important;
              }
              .rt-msg-panel.is-form-panel {
                padding-top: 4px !important;
              }
              @keyframes rtMsgTabFadeIn {
                from { opacity: 0; transform: translateY(6px); }
                to { opacity: 1; transform: translateY(0); }
              }

              .rt-msg-action-btn {
                display: inline-flex !important;
                align-items: center !important;
                gap: 8px !important;
                background: #ffffff !important;
                border: 1px solid #cbd5e1 !important;
                padding: 7px 14px !important;
                border-radius: 0 !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                color: #1e293b !important;
                box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
                cursor: pointer !important;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                outline: none !important;
                white-space: nowrap !important;
              }
              .rt-msg-action-btn:hover {
                background: #f8fafc !important;
                color: #1e293b !important;
                border-color: #94a3b8 !important;
                transform: translateY(-1px) !important;
                box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
              }
              .rt-msg-action-btn.is-primary {
                background: var(--task-accent, #2563eb) !important;
                color: #ffffff !important;
                border-color: var(--task-accent, #2563eb) !important;
              }
              .rt-msg-action-btn.is-primary:hover {
                background: var(--task-accent, #2563eb) !important;
                color: #ffffff !important;
                transform: translateY(-1px) !important;
                opacity: 0.9 !important;
                box-shadow: 0 4px 10px -1px var(--task-accent, rgba(37, 99, 235, 0.25)) !important;
              }

              .rt-msg-selected-card {
                display: flex !important;
                align-items: center !important;
                justify-content: space-between !important;
                gap: 20px !important;
                padding: 18px 22px !important;
                margin: 0 0 12px 0 !important;
                border: 1px solid rgba(37,99,235,0.12) !important;
                border-radius: 14px !important;
                background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%) !important;
                flex-wrap: wrap !important;
                animation: rtMsgTabFadeIn 0.3s ease both !important;
              }
              .rt-msg-selected-info {
                display: flex !important;
                align-items: center !important;
                gap: 14px !important;
                min-width: 0 !important;
              }
              .rt-msg-selected-avatar {
                width: 46px !important;
                height: 46px !important;
                border-radius: 12px !important;
                background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
                color: #ffffff !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                font-size: 18px !important;
                font-weight: 500 !important;
                flex-shrink: 0 !important;
                box-shadow: 0 4px 10px rgba(37,99,235,0.2) !important;
                border: 2px solid #ffffff !important;
              }
              .rt-msg-selected-meta {
                display: flex !important;
                flex-direction: column !important;
                gap: 4px !important;
                min-width: 0 !important;
              }
              .rt-msg-selected-meta strong {
                display: block !important;
                color: #1e293b !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                margin-bottom: 3px !important;
              }
              .rt-msg-selected-meta span {
                color: #64748b !important;
                font-size: 14px !important;
                font-weight: 400 !important;
                display: flex !important;
                align-items: center !important;
                gap: 7px !important;
                flex-wrap: wrap !important;
              }
              .rt-msg-selected-actions {
                display: flex !important;
                align-items: center !important;
                gap: 8px !important;
                flex-wrap: wrap !important;
                flex-shrink: 0 !important;
              }
              .rt-msg-selected-actions .rt-form-action-btn {
                height: 38px !important;
                box-sizing: border-box !important;
                justify-content: center !important;
              }
              .rt-msg-selected-actions .rt-form-action-btn.is-clear {
                min-width: auto !important;
                width: 38px !important;
                padding: 0 !important;
              }

              .rt-msg-table-scroll {
                overflow: auto !important;
                max-height: 460px !important;
                border-radius: 0.375rem !important;
                position: relative !important;
                scrollbar-width: thin !important;
                scrollbar-color: #94a3b8 #f1f5f9 !important;
              }
              .rt-msg-table {
                width: 100%;
                margin-bottom: 0;
                margin-top: 0px !important;
                border: none;
                border-collapse: separate;
                border-spacing: 0;
                color: var(--text-main, #1e293b);
              }
              .rt-msg-table thead {
                position: sticky;
                top: 0;
                z-index: 2;
                background: var(--bg-light, #f8fafc);
              }
              .rt-msg-table thead tr th:first-child {
                border-top-left-radius: 0.375rem !important;
              }
              .rt-msg-table thead tr th:last-child {
                border-top-right-radius: 0.375rem !important;
              }
              .rt-msg-table thead th {
                color: var(--text-muted, #64748b);
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 0.05em;
                text-transform: uppercase;
                padding: 12px 16px;
                border-top: none;
                border-bottom: 1px solid var(--border-color, #e2e8f0);
                white-space: nowrap;
              }
              .rt-form-workbench .rt-msg-table td {
                padding: 14px 16px;
                font-size: 14px;
                font-weight: 400;
                color: var(--text-main, #1e293b);
                vertical-align: middle;
                border-top: none;
                border-bottom: 1px solid var(--border-color, #e2e8f0);
                background: transparent !important;
                background-color: transparent !important;
                transition: all 0.15s ease;
              }
              .rt-form-workbench .rt-msg-table tbody tr:last-child td {
                border-bottom: none;
              }
              .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row {
                cursor: pointer;
                transition: transform 0.1s ease !important;
              }
              .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:active {
                transform: scaleY(0.98) !important;
              }
              .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:hover td {
                background-color: rgba(37, 99, 235, 0.04) !important;
                color: #1e293b !important;
              }
              .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:hover td:first-child {
                box-shadow: inset 3px 0 0 0 rgba(37, 99, 235, 0.35) !important;
              }
              .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td {
                background-color: rgba(37, 99, 235, 0.07) !important;
                color: #1e3a8a !important;
                font-weight: 500 !important;
                border-bottom: 1px solid rgba(37, 99, 235, 0.08) !important;
              }
              .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td:first-child {
                box-shadow: inset 4px 0 0 0 #2563eb !important;
              }
              .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row:hover td {
                background-color: rgba(37, 99, 235, 0.09) !important;
              }

              .rt-msg-time {
                display: flex !important;
                flex-direction: column !important;
                align-items: flex-start !important;
                gap: 2px !important;
              }
              .rt-msg-time-row {
                display: flex !important;
                align-items: center !important;
                gap: 6px !important;
              }
              .rt-msg-time-date {
                font-weight: 400 !important;
                color: #1e293b !important;
              }
              .rt-msg-time-subtext {
                font-size: 14px !important;
                font-weight: 400 !important;
                color: var(--text-muted, #64748b) !important;
                padding-left: 30px !important;
              }
              .rt-msg-time-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                border-radius: 6px;
                background: var(--bg-light, #f8fafc);
                color: var(--text-muted, #64748b);
                font-size: 12px;
              }

              .rt-msg-empty-state {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                min-height: 220px;
                padding: 36px 20px;
                text-align: center;
                background: #ffffff;
                border-radius: 12px;
              }
              .rt-msg-empty-icon {
                width: 48px;
                height: 48px;
                border-radius: 12px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                background: var(--primary-soft, #eff6ff);
                color: var(--primary-color, #2563eb);
                font-size: 20px;
                margin-bottom: 16px;
              }
              .rt-msg-empty-title { margin: 0; color: var(--text-main, #1e293b); font-size: 14px; font-weight: 500; }
              .rt-msg-empty-desc { margin: 6px 0 0; color: var(--text-muted, #64748b); font-size: 14px; font-weight: 400; }

              .wf-name-cell {
                display: flex !important;
                align-items: center !important;
                gap: 10px !important;
                min-width: 190px !important;
              }
              .wf-name-avatar {
                width: 34px !important;
                height: 34px !important;
                border-radius: 10px !important;
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1)) !important;
                border: 1px solid rgba(37,99,235,0.16) !important;
                color: #1d4ed8 !important;
                font-size: 12px !important;
                font-weight: 600 !important;
                flex-shrink: 0 !important;
              }
              .wf-name-meta {
                display: flex !important;
                flex-direction: column !important;
                gap: 2px !important;
                min-width: 0 !important;
              }
              .wf-name-main {
                font-weight: 400 !important;
                color: #1e293b !important;
                font-size: 14px !important;
                line-height: 1.2 !important;
              }
              .wf-name-title {
                font-size: 14px !important;
                color: #64748b !important;
                font-weight: 400 !important;
                line-height: 1.2 !important;
              }
              .wf-empty-value {
                color: #64748b !important;
                font-size: 14px !important;
                font-weight: 400 !important;
                line-height: 1.2 !important;
              }

              .rt-form-status-tag {
                font-size: 12px !important;
                font-weight: 600 !important;
                text-transform: uppercase !important;
                padding: 2px 6px !important;
                border-radius: 4px !important;
                letter-spacing: 0.02em !important;
                display: inline-block !important;
              }
              .rt-form-status-tag.is-updated {
                background: #ecfdf5 !important;
                color: #065f46 !important;
                border: 1px solid #a7f3d0 !important;
              }
              .rt-form-status-tag.is-pending {
                background: #fffbeb !important;
                color: #92400e !important;
                border: 1px solid #fde68a !important;
              }

              .rt-form-remarks {
                font-size: 14px !important;
                font-weight: 400 !important;
                color: #64748b !important;
                line-height: 1.4 !important;
                background: #f8fafc !important;
                padding: 4px 8px !important;
                border-radius: 6px !important;
                border-left: 3px solid #cbd5e1 !important;
                display: inline-block !important;
              }

              .rt-form-buttons-row {
                display: flex !important;
                align-items: center !important;
                gap: 6px !important;
                flex-wrap: wrap !important;
              }
              .rt-form-action-btn {
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 7px !important;
                background: #ffffff !important;
                border: 1px solid #cbd5e1 !important;
                padding: 7px 14px !important;
                border-radius: 0 !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                color: #1e293b !important;
                box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
                cursor: pointer !important;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                outline: none !important;
                white-space: nowrap !important;
                min-width: 90px !important;
                text-transform: none !important;
              }
              .rt-form-action-btn:hover {
                background: #f8fafc !important;
                color: #1e293b !important;
                border-color: #94a3b8 !important;
                transform: translateY(-1.5px) !important;
                box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
              }
              .rt-form-action-btn.is-delete {
                border-color: #ef4444 !important;
                color: #ef4444 !important;
                min-width: auto !important;
              }
              .rt-form-action-btn.is-delete:hover {
                background: #ef4444 !important;
                color: #ffffff !important;
                border-color: #ef4444 !important;
                box-shadow: 0 4px 10px -1px rgba(239, 68, 68, 0.25) !important;
              }
              .rt-form-action-btn.is-view {
                border-color: var(--task-accent, #3b82f6) !important;
                color: var(--task-accent, #3b82f6) !important;
              }
              .rt-form-action-btn.is-view:hover {
                background: var(--task-accent, #3b82f6) !important;
                color: #ffffff !important;
                border-color: var(--task-accent, #3b82f6) !important;
                box-shadow: 0 4px 10px -1px rgba(59, 130, 246, 0.25) !important;
              }
              .rt-form-action-btn.is-edit {
                border-color: #10b981 !important;
                color: #10b981 !important;
              }
              .rt-form-action-btn.is-edit:hover {
                background: #10b981 !important;
                color: #ffffff !important;
                border-color: #10b981 !important;
                box-shadow: 0 4px 10px -1px rgba(16, 185, 129, 0.25) !important;
              }
              .rt-form-action-btn.is-history-btn {
                border-color: #8b5cf6 !important;
                color: #8b5cf6 !important;
              }
              .rt-form-action-btn.is-history-btn:hover {
                background: #8b5cf6 !important;
                color: #ffffff !important;
                border-color: #8b5cf6 !important;
                box-shadow: 0 4px 10px -1px rgba(139, 92, 246, 0.25) !important;
              }
              .rt-action-label-badge {
                font-size: 12px !important;
                font-weight: 600 !important;
                text-transform: uppercase !important;
                padding: 7px 12px !important;
                border-radius: 8px !important;
                letter-spacing: 0.02em !important;
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 7px !important;
                min-width: 90px !important;
              }
              .rt-action-label-badge.is-sent {
                background: #ecfdf5 !important;
                color: #065f46 !important;
                border: 1px solid #a7f3d0 !important;
              }

              .rt-msg-table th .rt-th-id-wrapper {
                display: flex !important;
                align-items: center !important;
                gap: 8px !important;
              }
              .rt-msg-table th .rt-id-reset-btn {
                cursor: pointer !important;
                display: inline-flex !important;
                align-items: center !important;
              }
              .rt-msg-table th .rt-id-reset-btn i {
                font-size: 11px !important;
                color: var(--task-accent, #2563eb) !important;
              }
              .rt-msg-id-cell-span {
                font-weight: 400 !important;
                color: #1e293b !important;
                font-size: 14px !important;
                display: inline-flex !important;
                align-items: center !important;
                gap: 6px !important;
              }
              .selected-row .rt-msg-id-cell-span {
                color: var(--task-accent, #2563eb) !important;
              }
              .rt-msg-id-cell-span i.selected-icon {
                font-size: 12px !important;
                color: var(--task-accent, #2563eb) !important;
              }

              .rt-editor-toolbar {
                display: flex !important;
                justify-content: space-between !important;
                align-items: center !important;
                padding: 12px 16px !important;
                background: #f8fafc !important;
                border: 1px solid #e2e8f0 !important;
                border-radius: 8px !important;
                margin-bottom: 12px !important;
              }
              .rt-editor-toolbar-title {
                font-size: 12px !important;
                font-weight: 600 !important;
                color: #64748b !important;
                display: inline-flex !important;
                align-items: center !important;
                gap: 6px !important;
                text-transform: uppercase !important;
                letter-spacing: 0.02em !important;
              }
              .rt-editor-toolbar-reset {
                background: transparent !important;
                border: none !important;
                color: var(--task-accent, #3b82f6) !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                cursor: pointer !important;
                display: inline-flex !important;
                align-items: center !important;
                gap: 5px !important;
                padding: 4px 8px !important;
                border-radius: 4px !important;
                transition: all 0.2s ease !important;
              }
              .rt-editor-toolbar-reset:hover {
                background: var(--task-soft, #eff6ff) !important;
              }

              .rt-editor-search-bar {
                display: flex !important;
                gap: 8px !important;
                align-items: center !important;
                background: #ffffff !important;
                padding: 12px !important;
                border: 1px solid #e2e8f0 !important;
                border-radius: 8px !important;
              }
              .rt-search-actions {
                display: flex !important;
                gap: 6px !important;
              }

              .rt-editor-version-tag {
                font-size: 12px !important;
                font-weight: 600 !important;
                text-transform: uppercase !important;
                background: #f1f5f9 !important;
                color: #64748b !important;
                border: 1px solid #e2e8f0 !important;
                padding: 1px 5px !important;
                border-radius: 4px !important;
                letter-spacing: 0.02em !important;
                display: inline-block !important;
              }

              .custom-radio-wrapper {
                position: relative !important;
                width: 16px !important;
                height: 16px !important;
              }
              .custom-radio-wrapper input {
                position: absolute !important;
                opacity: 0 !important;
                cursor: pointer !important;
                width: 100% !important;
                height: 100% !important;
                margin: 0 !important;
                z-index: 2 !important;
              }
              .custom-radio-checkmark {
                position: absolute !important;
                top: 0 !important;
                left: 0 !important;
                height: 16px !important;
                width: 16px !important;
                background-color: #ffffff !important;
                border: 2px solid #cbd5e1 !important;
                border-radius: 50% !important;
                z-index: 1 !important;
                transition: all 0.2s ease !important;
              }
              .custom-radio-wrapper:hover input ~ .custom-radio-checkmark {
                border-color: var(--task-accent, #3b82f6) !important;
              }
              .custom-radio-wrapper input:checked ~ .custom-radio-checkmark {
                border-color: var(--task-accent, #3b82f6) !important;
                background-color: var(--task-accent, #3b82f6) !important;
              }
              .custom-radio-checkmark:after {
                content: "" !important;
                position: absolute !important;
                display: none !important;
                top: 4px !important;
                left: 4px !important;
                width: 4px !important;
                height: 4px !important;
                border-radius: 50% !important;
                background: #ffffff !important;
              }
              .custom-radio-wrapper input:checked ~ .custom-radio-checkmark:after {
                display: block !important;
              }

              .rt-form-name-link {
                font-weight: 500 !important;
                color: var(--task-accent, #2563eb) !important;
                font-size: 14px !important;
                text-align: left !important;
                text-decoration: none !important;
                display: inline-flex !important;
                align-items: center !important;
                text-transform: none !important;
                background: transparent !important;
                border: none !important;
                padding: 0 !important;
                box-shadow: none !important;
                cursor: pointer !important;
                transition: color 0.2s ease !important;
              }
              .rt-form-name-link .rt-form-name-text {
                text-decoration: none !important;
                transition: text-decoration 0.2s ease !important;
              }
              .rt-form-name-link:hover .rt-form-name-text {
                color: var(--primary-hover, #1d4ed8) !important;
                text-decoration: underline !important;
              }
              .rt-form-name-link:focus {
                outline: none !important;
                box-shadow: none !important;
              }

              .rt-status-tags-wrapper {
                display: flex !important;
                align-items: center !important;
                gap: 8px !important;
                flex-wrap: wrap !important;
                margin-top: 4px !important;
              }
              .rt-status-tags-wrapper .rt-form-status-tag {
                height: 24px !important;
                display: inline-flex !important;
                align-items: center !important;
                gap: 4px !important;
              }

              .rt-form-action-btn.is-notes-btn {
                min-width: auto !important;
                padding: 7px 14px !important;
                font-size: 14px !important;
                font-weight: 500 !important;
              }

              /* Specific scoping to guarantee padding-left overrides any other style definitions */
              .rt-editor-tabs .rt-editor-search-bar .wf-input-wrap .wf-input-icon {
                position: absolute !important;
                left: 14px !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                color: #94a3b8 !important;
                font-size: 14px !important;
                z-index: 10 !important;
                pointer-events: none !important;
              }
              .rt-editor-tabs .rt-editor-search-bar .wf-input-wrap .form-control {
                padding-left: 45px !important;
                height: 38px !important;
                border-radius: 9px !important;
                border: 1.5px solid #cbd5e1 !important;
                font-size: 14px !important;
                font-weight: 400 !important;
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                width: 100% !important;
                display: block !important;
              }

              /* ── View Template Modal ───────────────────── */
              .rt-view-template-modal .modal-content {
                border: none !important;
                border-radius: 16px !important;
                overflow: hidden !important;
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.04) !important;
              }

              .rt-view-template-modal .modal-dialog {
                max-width: 768px !important;
              }

              .rt-vtm-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 18px 24px;
                background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
                border-bottom: 1px solid #e2e8f0;
              }

              .rt-vtm-header-left {
                display: flex;
                align-items: center;
                gap: 14px;
                min-width: 0;
              }

              .rt-vtm-header-icon {
                flex-shrink: 0;
                width: 42px;
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 12px;
                background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                color: #ffffff;
                font-size: 17px;
                box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
              }

              .rt-vtm-header-text {
                min-width: 0;
              }

              .rt-vtm-header-title {
                font-size: 18px !important;
                font-weight: 500 !important;
                color: #1e293b !important;
                margin: 0 0 2px 0 !important;
                line-height: 1.3 !important;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 600px;
              }

              .rt-vtm-header-subtitle {
                font-size: 14px !important;
                font-weight: 400 !important;
                color: #64748b !important;
                margin: 0 !important;
                line-height: 1.3 !important;
              }

              .rt-vtm-close-btn {
                flex-shrink: 0;
                width: 36px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px;
                border: 1.5px solid #e2e8f0;
                background: #ffffff;
                color: #64748b;
                font-size: 16px;
                cursor: pointer;
                transition: all 0.2s ease;
                outline: none;
                padding: 0;
                line-height: 1;
              }

              .rt-vtm-close-btn:hover {
                background: #f1f5f9;
                border-color: #cbd5e1;
                color: #1e293b;
                transform: scale(1.05);
              }

              .rt-vtm-body {
                padding: 0 !important;
                background: #ffffff;
              }

              .rt-vtm-body-inner {
                height: 550px;
                overflow-y: auto;
                padding: 24px;
                scrollbar-width: thin;
                scrollbar-color: #cbd5e1 transparent;
              }

              .rt-vtm-body-inner::-webkit-scrollbar {
                width: 6px;
              }

              .rt-vtm-body-inner::-webkit-scrollbar-track {
                background: transparent;
              }

              .rt-vtm-body-inner::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 3px;
              }

              .rt-vtm-body-inner::-webkit-scrollbar-thumb:hover {
                background: #94a3b8;
              }

              .rt-vtm-preview-content {
                background: #ffffff;
                border: 1px solid #e2e8f0;
                border-radius: 8px;
                padding: 30px;
                box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
                min-height: 100%;
                color: #1e293b;
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                font-size: 14px;
                font-weight: 400;
                line-height: 1.6;
              }

              .rt-vtm-preview-content table {
                width: 100% !important;
                border-collapse: collapse !important;
                margin-bottom: 1rem !important;
              }
              .rt-vtm-preview-content table td,
              .rt-vtm-preview-content table th {
                border: 1px solid #cbd5e1 !important;
                padding: 8px 12px !important;
              }

              .rt-vtm-footer {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 14px 24px;
                background: #f8fafc;
                border-top: 1px solid #e2e8f0;
                gap: 10px;
              }

              .rt-vtm-footer-btn {
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 7px !important;
                padding: 7px 14px !important;
                border-radius: 0 !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                cursor: pointer !important;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                outline: none !important;
                border: 1px solid #cbd5e1 !important;
                background: #ffffff !important;
                color: #1e293b !important;
                box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
              }

              .rt-vtm-footer-btn:hover {
                background: #f1f5f9 !important;
                border-color: #94a3b8 !important;
                color: #1e293b !important;
                transform: translateY(-1px) !important;
                box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
              }
            `}</style>

            <div className="rt-msg-tab-bar">
                <button
                    type="button"
                    className={`rt-msg-tab-btn${selectedKey === "home" ? " active" : ""}`}
                    onClick={() => handleSelectTab("home")}
                >
                    <i className="fa fa-folder-open" aria-hidden="true" />
                    Case Reports
                    <span className="rt-msg-tab-badge">{wordTemplates.length}</span>
                </button>
                <button
                    type="button"
                    className={`rt-msg-tab-btn${selectedKey === "history" ? " active" : ""}`}
                    onClick={() => handleSelectTab("history")}
                >
                    <i className="fa fa-history" aria-hidden="true" />
                    Version History
                </button>
                <button
                    type="button"
                    className={`rt-msg-tab-btn${selectedKey === "add" ? " active" : ""}`}
                    onClick={() => handleSelectTab("add")}
                >
                    <i className="fa fa-plus" aria-hidden="true" />
                    {selectedTempId > 0 ? "Edit" : "Add"} Case Report
                </button>
            </div>

            {selectedKey === "home" && (
                <div className="rt-msg-panel">
                    {renderSelectedReportCard()}

                    <div className="rt-editor-search-bar mb-3">
                        <div className="wf-input-wrap" style={{ flex: 1 }}>
                            <i className="fa fa-search wf-input-icon" aria-hidden="true" />
                            <input
                                type="text"
                                placeholder="Search by name, notes, created by and document data..."
                                className="form-control"
                                id="txtSearch"
                                name="txtSearch"
                                onChange={({ currentTarget }) => setSearchParam(currentTarget.value)}
                                value={searchParam}
                            />
                        </div>
                        <div className="rt-search-actions">
                            <button
                                type="button"
                                className="rt-msg-action-btn is-primary"
                                onClick={handleClickSearch}
                                disabled={!searchParam}
                            >
                                <i className="fa fa-search mr-2" aria-hidden="true" /> Search
                            </button>
                            <button
                                type="button"
                                className="rt-msg-action-btn"
                                onClick={handleResetSearch}
                            >
                                <i className="fa fa-refresh mr-2" aria-hidden="true" /> Reset
                            </button>
                        </div>
                    </div>

                    <div className="table-responsive rt-msg-table-scroll">
                        <table className="table align-items-center table-flush rt-msg-table">
                            <thead>
                                {isLoading && (
                                    <tr style={{ height: "0px", padding: 0 }}>
                                        <th colSpan={6} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                                            <div className="wf-loading-bar" />
                                        </th>
                                    </tr>
                                )}
                                <tr>
                                    <th>
                                        <div className="rt-th-id-wrapper">
                                            <span>ID</span>
                                            {selectedTempId > 0 && (
                                                <span
                                                    className="rt-id-reset-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleResetSelection();
                                                    }}
                                                    title="Reset Selection"
                                                >
                                                    <i className="fa fa-refresh" aria-hidden="true" />
                                                </span>
                                            )}
                                        </div>
                                    </th>
                                    <th>Created</th>
                                    <th>Added By</th>
                                    <th>Report</th>
                                    <th>Notes</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    Array.from({ length: 5 }).map((_, i) => (
                                        <tr key={`skel-${i}`} className="skeleton-row">
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                            <td><span className="skeleton-cell sk-full" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.04}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                        </tr>
                                    ))
                                ) : wordTemplates.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} style={{ padding: 0 }}>
                                            <div className="rt-msg-empty-state">
                                                <div className="rt-msg-empty-icon">
                                                    <i className="fa fa-folder-open-o" aria-hidden="true" />
                                                </div>
                                                <p className="rt-msg-empty-title">No Case Reports Found</p>
                                                <p className="rt-msg-empty-desc">
                                                    There are currently no reports inside the template library.
                                                </p>
                                                <button
                                                    className="rt-msg-action-btn is-primary"
                                                    type="button"
                                                    onClick={() => handleSelectTab("add")}
                                                    style={{ marginTop: "12px" }}
                                                >
                                                    <i className="fa fa-plus" aria-hidden="true" /> Add Case Report
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    wordTemplates.map((item, key) => {
                                        const isSelected = selectedTempId === item.id;
                                        return (
                                            <tr
                                                key={item.id}
                                                className={`rt-msg-row ${isSelected ? "selected-row" : ""}`}
                                                onClick={() => handleSelectTemplate(item)}
                                                style={{ animationDelay: `${key * 0.04}s` }}
                                                title={isSelected ? `Click to deselect: Report #${item.id}` : `Click to select: Report #${item.id}`}
                                            >
                                                <td>
                                                    <span className="rt-msg-id-cell-span">
                                                        {isSelected && (
                                                            <i className="fa fa-check-circle selected-icon" />
                                                        )}
                                                        #{item.id}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="rt-msg-time">
                                                        <div className="rt-msg-time-row">
                                                            <span className="rt-msg-time-icon">
                                                                <i className="fa fa-calendar-o" aria-hidden="true" />
                                                            </span>
                                                            <span className="rt-msg-time-date">
                                                                <Moment format="MMM D, YYYY">{item.createdDateTime}</Moment>
                                                            </span>
                                                        </div>
                                                        <span className="rt-msg-time-subtext">
                                                            <Moment format="h:mm a">{item.createdDateTime}</Moment>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="wf-name-cell">
                                                        <span className="wf-name-avatar">
                                                            {(item.templateType || "System").split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase()}
                                                        </span>
                                                        <div className="wf-name-meta">
                                                            <span className="wf-name-main">{item.templateType || "System"}</span>
                                                            <span className="wf-name-title">Author</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="rt-form-cell-wrapper">
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="rt-form-name-link"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setViewTemp(item);
                                                                }}
                                                                title="Click to view template preview"
                                                            >
                                                                <span className="rt-form-name-text">{item.templateName}</span>
                                                                <span className="rt-editor-version-tag" style={{ marginLeft: "8px" }}>V{item.version}</span>
                                                            </button>
                                                        </div>
                                                        <div className="rt-status-tags-wrapper" onClick={(e) => e.stopPropagation()}>
                                                            <span className={`rt-form-status-tag ${item.isEdit ? "is-pending" : "is-updated"}`}>
                                                                {item.isEdit ? "Unlocked" : "Locked"}
                                                            </span>
                                                        </div>
                                                        {item.templateData && !isHtml(item.templateData) && (
                                                            <div className="rt-form-remarks" style={{ borderLeftColor: "#2563eb", background: "#eff6ff", marginTop: "4px" }}>
                                                                <strong>Tags:</strong> {item.templateData}
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    {item.notes ? (
                                                        getPopover(item.notes, key === 0 ? "bottom" : "top")
                                                    ) : (
                                                        <span className="wf-empty-value">No notes</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="rt-form-buttons-row" onClick={(e) => e.stopPropagation()}>
                                                        <button
                                                            type="button"
                                                            className="rt-form-action-btn is-edit"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedTemp(item);
                                                                setSelectedTempId(item.id);
                                                                setSelectedKey("add");
                                                            }}
                                                            title="Edit Case Report"
                                                            style={{ minWidth: "75px" }}
                                                        >
                                                            <i className="fa fa-pencil" aria-hidden="true" /> Edit
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="rt-form-action-btn is-history-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedTemp(item);
                                                                setSelectedTempId(item.id);
                                                                setSelectedKey("history");
                                                            }}
                                                            title="View Version History"
                                                            style={{ minWidth: "75px" }}
                                                        >
                                                            <i className="fa fa-history" aria-hidden="true" /> History
                                                        </button>
                                                        {item.isEdit ? (
                                                            <button
                                                                type="button"
                                                                className="rt-form-action-btn is-delete"
                                                                onClick={() => handleWordTemplateLock(item)}
                                                            >
                                                                <i className="fa fa-unlock-alt" aria-hidden="true" /> Lock
                                                            </button>
                                                        ) : (
                                                            <span className="rt-action-label-badge is-sent">
                                                                <i className="fa fa-lock" aria-hidden="true" /> Locked
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {selectedKey === "history" && (
                <div className="rt-msg-panel">
                    {selectedTempId === 0 ? (
                        <div className="rt-msg-empty-state">
                            <div className="rt-msg-empty-icon" style={{ background: "#fef3c7", color: "#d97706" }}>
                                <i className="fa fa-exclamation-triangle" aria-hidden="true" />
                            </div>
                            <p className="rt-msg-empty-title">No Report Selected</p>
                            <p className="rt-msg-empty-desc">
                                Please select a case report from the "Case Reports" tab first.
                            </p>
                            <button
                                className="rt-msg-action-btn is-primary"
                                type="button"
                                onClick={() => handleSelectTab("home")}
                                style={{ marginTop: "12px" }}
                            >
                                <i className="fa fa-arrow-left" aria-hidden="true" /> View Reports
                            </button>
                        </div>
                    ) : (
                        <WordVersionHistory
                            selectedTemp={selectedTemp}
                            handleVersionViewTemp={handleVersionViewTemp}
                            handlePreviewTemplate={setViewTemp}
                            handleWordTemplateLock={handleWordTemplateLock}
                        />
                    )}
                </div>
            )}

            {selectedKey === "add" && (
                <div className="rt-msg-panel is-form-panel">
                    <AddWordTemplate
                        handleSubmit={handleSubmit}
                        selectedItem={selectedTemp}
                        verSelectedTemp={verSelectedTemp}
                        handleEditAppointment={handleEditTemp}
                        workflowTask={workflowTask}
                        handleCancel={() => {
                            setSelectedKey("home");
                            setSelectedTemp(null);
                            setSelectedTempId(0);
                        }}
                    />
                </div>
            )}

            {/* Template View Modal */}
            <Modal show={Boolean(viewTemp)} onHide={() => setViewTemp(null)} size="lg" dialogClassName="rt-view-template-modal" backdrop="static">
                <div className="rt-vtm-header">
                    <div className="rt-vtm-header-left">
                        <div className="rt-vtm-header-icon">
                            <i className="fa fa-file-word-o" aria-hidden="true" />
                        </div>
                        <div className="rt-vtm-header-text">
                            <h5 className="rt-vtm-header-title">
                                {viewTemp?.templateName || "View Case Report"}
                            </h5>
                            <p className="rt-vtm-header-subtitle">
                                <i className="fa fa-info-circle" aria-hidden="true" style={{ marginRight: "4px" }} />
                                Version V{viewTemp?.version || 1} &bull; Author: {viewTemp?.templateType || "System"}
                            </p>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="rt-vtm-close-btn"
                        onClick={() => setViewTemp(null)}
                        title="Close"
                    >
                        <i className="fa fa-times" aria-hidden="true" />
                    </button>
                </div>

                <Modal.Body className="rt-vtm-body">
                    <div className="rt-vtm-body-inner">
                        <div 
                            className="rt-vtm-preview-content" 
                            dangerouslySetInnerHTML={{ __html: viewTemp?.templateData || "" }}
                        />
                    </div>
                </Modal.Body>

                <div className="rt-vtm-footer">
                    <button
                        type="button"
                        className="rt-vtm-footer-btn"
                        onClick={() => setViewTemp(null)}
                    >
                        <i className="fa fa-times" aria-hidden="true" /> Close
                    </button>
                </div>
            </Modal>
        </div>
    );
}

export default WordEditor;